import axios from 'axios';

const API = '/api/cus-ecommerce';

class CusECommerceService {
  async submitPartsOrder(payload) {
    const url = `${API}/submit-order`;
    const submitPartsOrderResponse = axios.post(url, payload);
    return submitPartsOrderResponse;
  }

  async sendMessage(payload) {
    const url = `${API}/message-branch`;
    const sendMessageResponse = axios.post(url, payload);
    return sendMessageResponse;
  }
}

export default new CusECommerceService();
